import { Component, input } from '@angular/core';

import { Subcategory } from '@casinocore/platform/core';

import { TopTenGamesComponent } from '../../top-ten-games/top-ten-games.component';

@Component({
    selector: 'cc-modular-container',
    template: `@switch (modularComponent()) {
        @case ('TopTenGamesComponent') {
            <cc-top-ten-games [lobbyType]="lobbyType()" [subCategory]="subcategory().categoryInfo" />
        }
    }`,
    imports: [TopTenGamesComponent],
})
export class ModularContainerComponent {
    subcategory = input.required<Subcategory>();
    lobbyType = input.required<string>();
    modularComponent = input<string>('');
}
